import { Reveal } from "../reveal";

export function SiteLengthGraphic({ from, to, note }: { from: string; to: string; note: string }) {
  return (
    <Reveal delay={0.1}>
      <div className="mt-10 border border-border bg-secondary/30 px-5 py-5 md:px-6">
        <div className="flex items-center justify-between gap-4">
          <span className="eyebrow text-foreground">{from}</span>
          <div className="relative h-px flex-1 bg-border">
            <span className="absolute left-0 top-1/2 size-2 -translate-y-1/2 rounded-full bg-primary" />
            <span className="absolute right-0 top-1/2 size-2 -translate-y-1/2 rounded-full bg-accent" />
          </div>
          <span className="eyebrow text-foreground">{to}</span>
        </div>
        <p className="mt-3 text-xs leading-relaxed text-muted-foreground">{note}</p>
      </div>
    </Reveal>
  );
}
